import React, {useState} from 'react';
import {Scrollbar} from "react-scrollbars-custom";

import Section from '../section/Section';
import Search from "../search/Search";

import sidebarStyles from './Sidebar.module.scss'


function Sidebar(props) {

    const [activeSection, setActiveSection] = useState(props.activeSection);

    const toggleSection = section => (() => {
        setActiveSection(activeSection === section ? null : section);
    })

    return (
        <div id = 'sidebar' className = {sidebarStyles.sidebar}>
            <Search location = {props.location}/>
            <div className = {sidebarStyles.scrollbarWrapper}>
                <Scrollbar
                    thumbYProps={{
                        renderer: props => {
                            const { elementRef, ...restProps } = props;
                            return <div {...restProps} ref = {elementRef} style = {{background: "#9CC6EA", cursor: "pointer"}} />;
                        }
                    }}
                    trackYProps={{
                        renderer: props => {
                            const { elementRef, ...restProps } = props;
                            return <div
                                {...restProps}
                                ref = {elementRef}
                                style = {{
                                    height: "100%",
                                    position: "absolute",
                                    overflow: "hidden",
                                    userSelect: "none",
                                    right: "0",
                                    width: "0.33rem",
                                    top: 0
                                }}
                            />;
                        }
                    }}
                    style = {{width: "100%", height: "100%"}}
                >
                    {props.sectionList.map((section, i) => (
                        <Section
                            createLink = {props.createLink}
                            isActive = {activeSection === section}
                            key = {i}
                            location = {props.location}
                            onSectionTitleClick = {toggleSection(section)}
                            section = {section}
                        />
                    ))}
                </Scrollbar>
            </div>
            <span className = {sidebarStyles.company}>Human Semantics</span>
        </div>
    );

}

export default Sidebar;
